export default function spliter(num) {
    if (num)
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
